import { render, staticRenderFns } from "./ExamineInfo.vue?vue&type=template&id=ca35630e&scoped=true"
import script from "./ExamineInfo.vue?vue&type=script&lang=js"
export * from "./ExamineInfo.vue?vue&type=script&lang=js"
import style0 from "./ExamineInfo.vue?vue&type=style&index=0&id=ca35630e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca35630e",
  null
  
)

export default component.exports